import {Component, OnInit} from '@angular/core';
import {PaymentHistoryImportsResource} from '../../model/model-resource';
import {take} from 'rxjs/operators';
import {PaymentHistoryImport} from '../../model/payment-history-import';
import {Subject, Observable} from 'rxjs';

@Component({
  selector: 'app-payment-history-import-page',
  templateUrl: './payment-history-import-page.component.html',
  styleUrls: ['./payment-history-import-page.component.scss']
})
export class PaymentHistoryImportPageComponent implements OnInit {

  columns = ['status', 'date', 'invoiceNumber', 'referenceNumber', 'amount'];

  importing = false;

  imports$: Observable<PaymentHistoryImport[]>;

  stats = {
    success: { count: 0, value: 0 },
    failure: { count: 0, value: 0 },
  };

  filter = true;

  private subject: Subject<PaymentHistoryImport[]>;
  private source: PaymentHistoryImport[];

  constructor(private paymentHistoryImportsResource: PaymentHistoryImportsResource) {
  }


  openInvoice(invoiceId): void {
    console.log(invoiceId);
  }

  import(): void {
    this.importing = true;
    this.paymentHistoryImportsResource
      .import()
      .pipe(take(1))
      .subscribe((imports: PaymentHistoryImport[]) => {
        this.importing = false;
        this.stats = {
          success: { count: 0, value: 0 },
          failure: { count: 0, value: 0 },
        };
        this.source = imports.sort((a: PaymentHistoryImport, b: PaymentHistoryImport) => a.date.getTime() - b.date.getTime());
        this.source.forEach(item => {
          if (item.success) {
            this.stats.success.count++;
            this.stats.success.value += item.amount;
          } else {
            this.stats.failure.count++;
            this.stats.failure.value += item.amount;
          }
        });
        this.provide();
      });
  }

  filterChanged(): void {
    this.filter = !this.filter;
    this.provide();
  }

  provide(): void {
    this.subject.next(this.source.filter(item => this.filter ? !item.success : true));
  }

  ngOnInit() {
    this.source = [];
    this.subject = new Subject<PaymentHistoryImport[]>();
    this.imports$ = this.subject.asObservable();
  }
}
